import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-confirm-button',
  templateUrl: './confirm-button.component.html',
  styleUrls: ['./confirm-button.component.scss']
})
export class ConfirmButtonComponent {
  @Input() data: any;
  @Input() label: string;
  @Input() labelConfirm: string;
  @Output() clickButton = new EventEmitter<any>();

  confirm = false;

  onClick() {
    if (this.confirm) {
      this.confirm = false;
      this.clickButton.emit(this.data);
    } else {
      this.confirm = true;
      setTimeout(()=> {
        this.confirm = false;
      }, 2000);
    }
  }
}
